import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { FormProvider } from "./FormProvider.js";
import { getStringValue, useForm, useFormCom } from "./utils.js";
const FormInitialization = ({ children, form, group, name, ...props })=>{
    const Form = useFormCom();
    const [formInstance] = useForm({
        group,
        name
    }, form ? Object.assign(form, {
        group,
        name
    }) : form);
    return /*#__PURE__*/ jsx(Form, {
        ...props,
        form: formInstance,
        name: formInstance.name,
        children: /*#__PURE__*/ jsx(FormProvider, {
            group: formInstance.group,
            name: formInstance.name,
            emit: formInstance.emit,
            children: children
        })
    });
};
const FormEvent = ({ children, form, group, name, ...props })=>{
    const formName = useMemo(()=>getStringValue([
            name,
            form?.name
        ]), [
        form?.name,
        name
    ]);
    const formGroup = useMemo(()=>getStringValue([
            form?.group,
            group
        ]), [
        form?.group,
        group
    ]);
    const Form = useFormCom();
    if (form?.emit && form.group === formGroup && form.name === formName) {
        const { focusField, ...formIns } = form;
        formIns.group = formGroup;
        return /*#__PURE__*/ jsx(Form, {
            ...props,
            form: {
                ...formIns,
                focusField: focusField ?? (()=>{})
            },
            name: formName,
            children: /*#__PURE__*/ jsx(FormProvider, {
                group: formGroup,
                name: formName,
                emit: form.emit,
                children: children
            })
        });
    }
    return /*#__PURE__*/ jsx(FormInitialization, {
        ...props,
        form: form,
        group: formGroup,
        name: formName,
        children: children
    });
};
const src_FormEvent = FormEvent;
export { src_FormEvent as default };
